const entities = ['plot', 'monster', 'encounter', 'rumour', 'lammie', 'research', 'ritual', 'network', 'systemPage']
export default Object.freeze(entities)
